// extracted by mini-css-extract-plugin
module.exports = {"section-container":"SectionContainer_section-container__2y7Wf","child-container":"SectionContainer_child-container__a27Qh"};